<template>
  <div style="width: 100%; height: 100%" ref="mychart"></div>
</template>
<script>
import * as echarts from 'echarts'
export default {
  name: 'ChartsBar',
  props: {
    title: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    data() {
      this.initMyChart() // 重置图表
    }
  },
  mounted() {
    // this.initMyChart()
    setTimeout(() => {
      this.initMyChart()
      const resizeOb = new ResizeObserver((entries) => {
        for (const entry of entries) {
          echarts.getInstanceByDom(entry.target).resize()
        }
      })
      resizeOb.observe(this.$refs.mychart)
    })
  },
  methods: {
    initMyChart() {
      // 基于准备好的dom，初始化echarts实例
      let mychart = echarts.getInstanceByDom(this.$refs.mychart)
      if (mychart == null) mychart = echarts.init(this.$refs.mychart)
      var colors = ['#667eea', '#19be6b']
      let xAxisData = []
      let seriesData = []
      let seriesList = []
      console.log(this.data)
      if (this.data) {
        xAxisData = this.data.xAxisData
        seriesData = this.data.seriesData //比率
        seriesList = this.data.seriesList
      }
      let option = {
        // 标题
        title: {
          text: this.title,
          left: 'center',
          top: 15,
          textStyle: {
            fontSize: 16,
            fontWeight: 'normal'
          }
        },
        // 工具提示
        tooltip: {
          trigger: 'axis',
          // formatter: '{b} <br/>{a} : {c}',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: xAxisData,
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '设备合格率',
            position: 'left',
            minInterval: 1,
            axisLine: {
              show: false,
              lineStyle: {
                color: colors[0]
              }
            },
            min: (value) => {
              // return value.min
              return Math.floor(value.min / 10) * 10
            },
            max: (value) => {
              // return Math.ceil(value.max / 100) * 100 + 300
              return Math.ceil(value.max)
            }
          },
          {
            type: 'value',
            name: `设\n备\n总\n数`,
            // offset: 20,
            position: 'right',
            // 位置
            nameLocation: 'middle',
            // 坐标轴名称与轴线距离
            nameGap: 30,
            // 坐标轴名称旋转
            nameRotate: 360,
            axisLine: {
              show: true,
              lineStyle: {
                color: colors[1]
              }
            },
            max: (value) => {
              // return Math.ceil(value.max / 100) * 100 + 300
              return value.max
            }
          }
        ],
        // 颜色配置
        color: colors,
        //让两条柱状合在一起
        // barGap: '-100%',
        // 类型配置
        series: [
          {
            name: '合格率',
            // 类型配置
            type: 'line',
            barWidth: '40%',
            barMaxWidth: '40%',

            // 数据配置
            data: seriesData,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  fontSize: 14,
                  position: 'insideTop',
                  // formatter: '{c}'
                  formatter: function (value) {
                    // 保留一位小数
                    return value.data.toFixed(1)
                  }
                }
              }
            }
          },
          {
            name: '合格数值',
            // // 类型配置
            type: 'line',
            yAxisIndex: 1,
            // 数据配置
            data: seriesList,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  fontSize: 14,
                  color: '#667eea',
                  position: 'top'
                  // formatter: '{c}'
                }
              }
            }
          }
        ]
      }
      mychart.setOption(option, true)
      // window.addEventListener('resize', this.resize)
    }
  }
}
</script>
